/**
 * Course Header Component
 *
 * Navigation bar for course detail page with back button, title, unlock button, and user controls.
 */

import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { getLocalizedTitle, UserProfileDropdown } from '@immopersian/common';
import { LanguageSwitcher } from '../LanguageSwitcher';

interface CourseHeaderProps {
  course: any;
  navigate: (path: string) => void;
  hasAccess: boolean;
  onUnlock: () => void;
}

export function CourseHeader({ course, navigate, hasAccess, onUnlock }: CourseHeaderProps) {
  const { t, i18n } = useTranslation();

  return (
    <header className="bg-brand-dark shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div>
            <button
              onClick={() => navigate('/')}
              className="text-brand-beige hover:text-white mb-1 flex items-center gap-2 text-sm"
            >
              <ArrowLeft className="w-4 h-4 rtl:rotate-180" />
              {t('courses.backToCourses')}
            </button>
            <h1 className="text-xl sm:text-2xl font-bold text-white">
              {getLocalizedTitle(course, i18n.language)}
            </h1>
          </div>
          <div className="flex items-center gap-4">
            {!hasAccess && (
              <button
                onClick={onUnlock}
                className="px-4 py-2 bg-brand-terracotta text-white text-sm rounded-lg hover:bg-brand-terracotta-dark font-medium transition-colors"
              >
                {t('courses.unlockCourse')}
              </button>
            )}
            <LanguageSwitcher />
            <UserProfileDropdown onNavigateToSettings={() => navigate('/settings')} />
          </div>
        </div>
      </div>
    </header>
  );
}
